module.exports = __webpack_public_path__ + "img/2025-10-15a_2.86383ab8.jpg";